import { Check, ReportProblem } from "@mui/icons-material";
import { Box, Card, CircularProgress, Divider, FormHelperText, Grid, Slide, Stack, TextField } from "@mui/material"
import { MuiTelInput } from "mui-tel-input";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MDBox from "../../../../components/MDBox";
import MDButton from "../../../../components/MDButton";
import MDSnackbar from "../../../../components/MDSnackbar";
import MDTypography from "../../../../components/MDTypography";
import PopUp from "../../../../components/PopUp/PopUp";
import { clearUpdateUserErrs, clearUpdateUserFieldErr, resetUpdatedUser, tryResetUpdateUserFormErr, tryUpdateUser } from "../../../../stateManagement/reducers/usersReducer";
import { tryConfirmLogin } from "../../../../stateManagement/reducers/authReducer";
import AnimateButton from "../../../../components/@extended/AnimateButton";

const EditBasicInfo = () => {


    const dispatch = useDispatch();
    const {
        user,
        authToken,
    } = useSelector(state => state.auth);
    const {
        updatingUser,
        updatedUser,
        updateUserErrs
    } = useSelector(state => state.users);

    const [firstName, setFirstName] = useState(user?.firstName ?? "");
    const [lastName, setLastName] = useState(user?.lastName ?? "");
    const [email, setEmail] = useState(user?.email ?? "");
    const [otherName, setOtherName] = useState(user?.otherName ?? "");
    const [nickName, setNickName] = useState(user?.nickName ?? "");
    const [preferredName, setPreferredName] = useState(user?.preferredName ?? "");
    const [phone, setPhone] = useState(user?.phone ?? "");
    const [about, setAbout] = useState(user?.about ?? "");

    const [request4Change, setRequest4Change] = useState(false);

    const handleFieldChange = (field) => {
        dispatch(clearUpdateUserFieldErr(field));

        if (updateUserErrs.form) {
            dispatch(tryResetUpdateUserFormErr());
        }

        setRequest4Change(true);
    }

    const mkFormData = () => {
        let formData = new FormData();

        if ((firstName !== "") && (firstName !== user?.firstName)) {
            formData.append("firstName", firstName);
        }

        if ((lastName !== "") && (lastName !== user?.lastName)) {
            formData.append("lastName", lastName);
        }

        if ((otherName !== "") && (otherName !== user?.otherName)) {
            formData.append("otherName", otherName);
        }

        if ((preferredName !== "") && (preferredName !== user?.preferredName)) {
            formData.append("preferredName", preferredName);
        }

        if ((email !== "") && (email !== user?.email)) {
            formData.append("email", email);
        }

        if ((phone !== "") && (phone !== user?.phone)) {
            formData.append("phone", phone);
        }

        if ((about !== "") && (about !== user?.about)) {
            formData.append("about", about);
        }

        return formData;
    }

    const [isInitRender1, setIsInitRender1] = useState(true);
    useEffect(() => {
        if (isInitRender1) {
            setIsInitRender1(false);
            return;
        }

        setRequest4Change(false);
    }, [updatedUser]);

    const [show, setShow] = useState(false);

    useEffect(() => {
        setShow(true);
        return () => {
            setShow(false);
        }
    }, []);

    return (
        <>
            <Slide direction="up" in={show} >
                <Box sx={{ height: "fit-content" }} >
                    <Card
                        sx={{
                            position: "relative",
                            mt: 2,
                            mx: 3,
                            py: 2,
                            px: 2,
                        }}
                    >
                        <MDTypography variant="h5" fontWeight="medium">Edit Basic Information</MDTypography>
                        <Grid container spacing={2} mt={1} sx={{ mb: "3.5rem" }}>
                            <Grid item xs={12} md={6}>
                                <Stack sx={{ width: "100%" }} alignItems="flex-start" spacing={1}>
                                    <TextField
                                        fullWidth
                                        id="editFirstName"
                                        label="First Name"
                                        value={firstName}
                                        error={Boolean(updateUserErrs.firstName)}
                                        onChange={e => {
                                            setFirstName(e.target.value);
                                            handleFieldChange("firstName");
                                        }}
                                        variant="standard"
                                    />
                                    {
                                        updateUserErrs.firstName

                                        &&

                                        <FormHelperText error id="update-firstName">
                                            {updateUserErrs.firstName}
                                        </FormHelperText>
                                    }
                                </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Stack sx={{ width: "100%" }} alignItems="flex-start" spacing={1}>
                                    <TextField
                                        fullWidth
                                        id="editLastName"
                                        label="Last Name"
                                        value={lastName}
                                        onChange={e => {
                                            setLastName(e.target.value);
                                            handleFieldChange("lastName");
                                        }}
                                        error={Boolean(updateUserErrs.lastName)}
                                        variant="standard"
                                    />
                                    {
                                        updateUserErrs.lastName

                                        &&

                                        <FormHelperText error id="update-lastName">
                                            {updateUserErrs.lastName}
                                        </FormHelperText>
                                    }
                                </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Stack sx={{ width: "100%" }} alignItems="flex-start" spacing={1}>
                                    <TextField
                                        fullWidth
                                        id="editOtherName"
                                        label="Other Name"
                                        value={otherName}
                                        onChange={e => {
                                            setOtherName(e.target.value);
                                            handleFieldChange("otherName")
                                        }}
                                        variant="standard"
                                        error={Boolean(updateUserErrs.otherName)}
                                    />
                                    {
                                        updateUserErrs.otherName

                                        &&

                                        <FormHelperText error id="update-otherName">
                                            {updateUserErrs.otherName}
                                        </FormHelperText>
                                    }
                                </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Stack sx={{ width: "100%" }} alignItems="flex-start" spacing={1}>
                                    <TextField
                                        fullWidth
                                        id="editPreferredName"
                                        label="Preferred Name"
                                        value={preferredName}
                                        onChange={e => {
                                            setPreferredName(e.target.value);
                                            handleFieldChange("preferredName");
                                        }}
                                        variant="standard"
                                        error={Boolean(updateUserErrs.preferredName)}
                                    />
                                    {
                                        updateUserErrs.preferredName

                                        &&

                                        <FormHelperText error id="update-preferredName">
                                            {updateUserErrs.preferredName}
                                        </FormHelperText>
                                    }
                                </Stack>
                            </Grid>
                            <Grid item xs={12} mt={4} mb={0}>
                                <Divider textAlign="left" >
                                    <MDTypography mt={-2}>
                                        Contact Details
                                    </MDTypography>
                                </Divider>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Stack sx={{ width: "100%" }} alignItems="flex-start" spacing={1}>
                                    <TextField
                                        fullWidth
                                        id="editEmail"
                                        label="E-Mail Address"
                                        value={email}
                                        onChange={e => {
                                            setEmail(e.target.value);
                                            handleFieldChange("email");
                                        }}
                                        variant="standard"
                                        error={Boolean(updateUserErrs.email)}
                                    />
                                    {
                                        updateUserErrs.email

                                        &&

                                        <FormHelperText error id="update-email">
                                            {updateUserErrs.email}
                                        </FormHelperText>
                                    }

                                </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Stack sx={{ width: "100%" }} alignItems="flex-start" spacing={1}>
                                    <MuiTelInput
                                        sx={{ position: 'relative' }}
                                        fullWidth
                                        // error={Boolean(signUpErrs.phone)}
                                        id='editPhone'
                                        value={phone}
                                        name='Phone Number*'
                                        label="Phone Number"
                                        onChange={e => {
                                            setPhone(e);
                                            handleFieldChange("phone");
                                        }}
                                        placeholder='803 912...'
                                        inputProps={{}}
                                        defaultCountry="NG"
                                        MenuProps={{ style: { zIndex: '6000000000' } }}
                                        variant="standard"
                                        error={Boolean(updateUserErrs.phone)}
                                    />
                                    {
                                        updateUserErrs.phone

                                        &&

                                        <FormHelperText error id="update-phone">
                                            {updateUserErrs.phone}
                                        </FormHelperText>
                                    }
                                </Stack>
                            </Grid>
                            <Grid item xs={12} mt={4} mb={0}>
                                <Divider textAlign="left" >
                                    <MDTypography mt={-2}>
                                        More Information
                                    </MDTypography>
                                </Divider>
                            </Grid>
                            <Grid item xs={12}>
                                <Stack sx={{ width: "100%" }} alignItems="flex-start" spacing={1}>
                                    <TextField
                                        fullWidth
                                        id="about"
                                        label="About Yourself"
                                        value={about}
                                        sx={{
                                            width: '100% !important',
                                            maxWidth: '100% !important'
                                        }}
                                        onChange={e => {
                                            setAbout(e.target.value);
                                            handleFieldChange("about");
                                        }}
                                        variant="standard"
                                        error={Boolean(updateUserErrs.about)}
                                    />
                                    {
                                        updateUserErrs.about

                                        &&

                                        <FormHelperText error id="update-email">
                                            {updateUserErrs.about}
                                        </FormHelperText>
                                    }

                                </Stack>
                            </Grid>
                        </Grid>
                        <Stack
                            sx={{
                                position: "absolute",
                                bottom: "1rem",
                                right: "1rem"
                            }}
                        >
                            <AnimateButton>
                                <MDButton
                                    variant="gradient"
                                    color="success"
                                    fullWidth
                                    onClick={e => {
                                        e.preventDefault();

                                        if (request4Change) {

                                            const formData = mkFormData();

                                            dispatch(tryUpdateUser({
                                                authToken: authToken ?? "",
                                                userId: user?._id ?? "",
                                                data: formData
                                            }))
                                        }
                                    }}
                                >
                                    {
                                        updatingUser

                                        &&

                                        'Saving Changes...'
                                    }
                                    {
                                        !updatingUser

                                        &&

                                        'Save Changes'
                                    }
                                </MDButton>
                            </AnimateButton>
                        </Stack>
                    </Card>
                </Box>
            </Slide>
        </>
    );
}

export default EditBasicInfo;